import axios from "axios";
import { config } from "config";
import Cookies from "js-cookie";
const httpAdapter = require("axios/lib/adapters/http");

export const apiPrivateService = axios.create({
  baseURL: config.apiURL + "/api",
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Access: "application/json",
  },
});
apiPrivateService.interceptors.request.use((config: any) => {
  const token = Cookies.get("access_token") || null;
  const xUserPhone = Cookies.get("x-user-phone") || null;

  const tokenHeaders = {
    Authorization: `Bearer ${token}`,
    "x-user-phone": xUserPhone,
  };
  if (config.headers) {
    config.headers = {
      ...config.headers,
      ...tokenHeaders,
    };
  } else {
    config.headers = tokenHeaders;
  }
  return config;
});

export const apiPublicService = axios.create({
  baseURL: config.apiURL + "/api",
  adapter: httpAdapter,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
});
export const apiOtpService = axios.create({
  baseURL: config.otpUrl + "/api/v1",
  adapter: httpAdapter,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
});

export const apiPublicImagesService = axios.create({
  baseURL: config.apiURL + "/api",
  adapter: httpAdapter,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "multipart/form-data",
  },
});

apiPublicImagesService.interceptors.request.use((config) => {
  const token = Cookies.get("access_token") || null;
  const tokenHeaders = {
    Authorization: `Bearer ${token}`,
  };
  if (config.headers) {
    config.headers = {
      ...config.headers,
      ...tokenHeaders,
    };
  } else {
    config.headers = tokenHeaders;
  }
  return config;
});

export const apiPrivateStorageService = axios.create({
  baseURL: config.apiURL,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Access: "application/json",
  },
});
